
import { useState } from "react";
import { Session } from "@supabase/supabase-js";
import { UserProfile } from "@/lib/types";
import { ExtendedUser } from "@/contexts/auth-types";
import { AuthStateType } from "./types/auth-state";

export function useAuthState(): AuthStateType {
  const [session, setSession] = useState<Session | null>(null);
  const [user, setUser] = useState<ExtendedUser | null>(null);
  const [profile, setProfile] = useState<UserProfile | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isSuperuser, setIsSuperuser] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [originalUser, setOriginalUser] = useState<any>(null);
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [isRecoverySession, setIsRecoverySession] = useState(false);

  return {
    session,
    setSession,
    user,
    setUser,
    profile,
    setProfile,
    isLoading,
    setIsLoading,
    isSuperuser,
    setIsSuperuser,
    isAdmin,
    setIsAdmin,
    originalUser,
    setOriginalUser,
    isImpersonating,
    setIsImpersonating,
    isRecoverySession,
    setIsRecoverySession,
  };
}
